/* CUSTOM set-configurator — grafischer Set-Konfigurator (Apple-Prinzip in Bone/Mono).
   Stück = TYP; pro Ebene Form (Schalter) × Glasur (Swatches) → Objekt morpht.
   Anzahl NICHT vorwählen — Rabatt entsteht dynamisch aus der Stückzahl.
   Stapel gruppiert NEBENEINANDER: Cups | Bowls | Plates. Konturen aus form_spec. Kein App. */
(function () {
  var root = document.querySelector('[data-setcfg]');
  if (!root || root.__init) return; root.__init = true;

  var SUF = { Edge:"EG", Round:"RD", Special:"SP", Bevel:"BV" }, FORD = { Edge:0, Bevel:1, Special:2 }, CATORD = { C:0, B:1, P:2 };   // Round NICHT in Mix&Match → hier ausgefiltert

  // Glasur-Info (hex→rgb, shine) aus den glaze-Metaobjekten (window.SETCFG_GLAZES, live via Liquid).
  var GLZINFO = {};
  (window.SETCFG_GLAZES || []).forEach(function (g) { GLZINFO[g.name] = { rgb: hex2rgb(g.hex), shine: g.shine != null ? Math.max(0, Math.min(1, g.shine / 100)) : 0.4, inset: g.in_set !== false }; });
  function glzInfo(nm) { return GLZINFO[nm] || { rgb: hex2rgb('#D7CDBF'), shine: 0.4, inset: false }; }
  // Profil je Code (form_spec, gebacken in set-configurator-data.js).
  var PROFILE = {};
  (window.SETCFG_FORMS || []).forEach(function (e) { if (e && e.code) PROFILE[e.code] = e; });
  // TYPES aus den Fallback-Produkten (window.SETCFG_PRODUCTS) — LIVE aus Liquid ueber die Collection
  // `studio`. SPOT ist das Produkt mit seinen VARIANTEN: erst holen wir, was es gibt (Made-to-order-
  // Varianten = die angebotenen Formen), dann die Informationen dazu (Geometrie/Glasurfarbe aus den
  // Metaobjekten). Glasuren bleiben `custom.glasuren` am Produkt — sie sind keine Varianten-Achse,
  // sondern Line-Item-Property, und das ist Folkes Hebel zum Reduzieren.
  // Je Typ: verfügbare Formen (custom.formen, Round gefiltert) + Glasuren (custom.glasuren) + Studio-Preis/Varianten-IDs + nur_innen.
  var TYPES = (window.SETCFG_PRODUCTS || []).filter(function (p) { return CATORD.hasOwnProperty(('' + p.typ).charAt(0)); }).map(function (p) {
    // Die Varianten SIND das Angebot: keine Kreuzpruefung gegen ein Metafeld mehr, das dasselbe
    // behauptet. Existiert "Made to order / Edge", gibt es Edge — sonst nicht.
    var forms = Object.keys(p.fv || {}).filter(function (fn) { return FORD.hasOwnProperty(fn); }).map(function (fn) {
      var prof = PROFILE[p.typ + SUF[fn]];
      return prof ? { form: fn, code: prof.code, vid: (p.fv && p.fv[fn]) || 0, o: prof.o, i: prof.i || [], fr: prof.fr || 0, fh: prof.fh || 0, sh: prof.sh, sr: prof.sr, _o: FORD[fn] } : null;
    }).filter(Boolean).sort(function (a, b) { return a._o - b._o; });
    return { typ: p.typ, name: p.name, price: p.price, ni: !!p.ni, glazes: p.glazes || [], forms: forms };  // vid/vid2 (Studio) entfallen — die Studio-Varianten sind POS-only, der Cart nutzt nur f.vid (MTO)
  }).filter(function (t) { return t.forms.length; }).sort(function (a, b) { return (CATORD[a.typ.charAt(0)] - CATORD[b.typ.charAt(0)]) || (a.typ < b.typ ? -1 : 1); });

  // Verfügbare Formen (für die Form-zuerst-Wahl)
  var AVAILFORMS = (function () { var s = {}; TYPES.forEach(function (t) { t.forms.forEach(function (f) { s[f.form] = 1; }); }); return ["Edge","Bevel","Special"].filter(function (f) { return s[f]; }); })();
  var gForm = AVAILFORMS[0] || "Edge";
  // Glasuren live aus dem Metaobjekt `glaze` (window.SETCFG_GLAZES via Liquid) —
  // Name, Farbe (hex→rgb) und Formen, für die die Glasur gilt. Fallback: SSOT-Werte.
  function hex2rgb(h) {
    h = ('' + h).replace('#', ''); if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16); return (n>>16 & 255)+','+(n>>8 & 255)+','+(n & 255);
  }
  // Glasur-Palette gesamt = Vereinigung aller Typ-Glasuren (Reihenfolge des ersten Auftretens). Pro Typ filtert der Picker.
  var GLAZES = (function () {
    var seen = {}, list = [];
    TYPES.forEach(function (t) { t.glazes.forEach(function (nm) { if (!seen[nm]) { seen[nm] = 1; var i = glzInfo(nm); if (i.inset) list.push({ name: nm, rgb: i.rgb, shine: i.shine }); } }); });   // Brick/Olive (in_set=false) raus aus Mix&Match
    return list.length ? list : [{ name: "Clear", rgb: hex2rgb('#D7CDBF'), shine: 0.4 }];
  })();
  function glazeShine(gi) { return GLAZES[gi] ? GLAZES[gi].shine : 0.4; }   // 0 = unglasiert/roh
  // Roher/unglasierter Tonkörper (Außenseite bei „nur innen"): aus Clear, etwas heller + ganz leicht grauer.
  var RAW_CLAY = (function () {
    var c = hex2rgb('#D7CDBF').split(',').map(Number);
    var lt = c.map(function (n) { return n + (255 - n) * 0.12; });          // heller
    var m = (lt[0] + lt[1] + lt[2]) / 3;
    return lt.map(function (n) { return Math.round(n + (m - n) * 0.2); }).join(',');   // leicht grauer (Richtung Mittelwert)
  })();
  // Gilt die Glasur für die aktuelle Form? (leere Formen-Liste = für alle)
  function glazeOK(gi) { return true; }   // Stufe B: Glasuren kommen pro Typ aus custom.glasuren (kein Form-Filter mehr)
  var S = 8, K = 0.26, MAX = parseInt(root.getAttribute('data-max'), 10) || 16, UID = 0;
  var PINSEL = window.SETCFG_PINSEL || [];                 // Brush-Vektor-Varianten (Asset)
  var SPECS = window.SETCFG_SPECS || {};                   // Maße je Code (form_spec)
  function hstr(s) { var h = 2166136261; s = '' + s; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return ((h >>> 0) % 1000) / 1000; }
  function isBrush(gi) { return GLAZES[gi] && /brush/i.test(GLAZES[gi].name); }
  function darken(rgb, f) { return rgb.split(',').map(function (n) { return Math.round(Math.max(0, Math.min(255, +n * f))); }).join(','); }
  function lighten(rgb, f) { return rgb.split(',').map(function (n) { n = +n; return Math.round(n + (255 - n) * f); }).join(','); }
  var $ = function (s) { return root.querySelector(s); };

  var THRESH = (root.getAttribute('data-sizes') || '2,4,6').split(',').map(function (x) { return parseInt(x, 10); });
  var DISCS  = (root.getAttribute('data-discounts') || '5,10,15').split(',').map(function (x) { return parseInt(x, 10); });
  function discFor(n) { var d = 0; for (var i = 0; i < THRESH.length; i++) { if (n >= THRESH[i]) d = DISCS[i]; } return d; }
  function nextTier(n) { for (var i = 0; i < THRESH.length; i++) { if (n < THRESH[i]) return { need: THRESH[i]-n, disc: DISCS[i] }; } return null; }

  function formOf(it) { return TYPES[it.t].forms[it.form]; }
  var fH   = function (f) { return f.o[f.o.length-1][1]; };            // Rand-Höhe (oben)
  var fRim = function (f) { return f.o[f.o.length-1][0]; };            // Außen-Randradius
  var fMaxR= function (f) { var m=0,o=f.o; for(var k=0;k<o.length;k++) if(o[k][0]>m) m=o[k][0]; return m; };
  function reduced() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
  // Abgeleitete Geometrie aus dem vollen Profil (Außen o / Innenrand fr,fh).
  function geo(sh) {
    var o = sh.o;
    var ro = o[o.length-1][0], yr = o[o.length-1][1], maxR = 0;
    for (var k=0;k<o.length;k++) if (o[k][0] > maxR) maxR = o[k][0];
    var plate = !sh.fr || sh.fr < ro * 0.3;                    // flache Teller: keine echte Wandung
    var innerR = plate ? Math.max(ro - 0.4, ro * 0.86) : sh.fr;
    return { o:o, ro:ro, yr:yr, maxR:maxR, baseR:o[0][0], innerR:innerR, plate:plate };
  }
  // Profil-Funktionen für Nesting: ro(y)=Außenradius, ri(y)=Innenradius (Kavität).
  function interp(a, y) {
    if (!a.length) return 0;
    if (y <= a[0][0]) return a[0][1];
    if (y >= a[a.length-1][0]) return a[a.length-1][1];
    for (var k=1;k<a.length;k++){ if (a[k][0] >= y){ var p=a[k-1],q=a[k],t=(y-p[0])/((q[0]-p[0])||1); return p[1]+(q[1]-p[1])*t; } }
    return a[a.length-1][1];
  }
  function pf(sh) {
    var g = geo(sh);
    var outer = g.o.map(function (p){ return [p[1],p[0]]; }).sort(function (a,b){ return a[0]-b[0]; });
    var inner = (sh.i||[]).map(function (p){ return [p[1],p[0]]; }).sort(function (a,b){ return a[0]-b[0]; });
    return { yr:g.yr, baseR:g.baseR, hasInner: inner.length>0, floorY: inner.length?inner[0][0]:0,
      ro:function(y){ return interp(outer,y); }, ri:function(y){ return inner.length?interp(inner,y):0; } };
  }
  // Wie tief sinkt U (kleiner/gleich) in L (darunter)? cm, um die U's Boden über L's Boden liegt.
  // off = seitlicher Versatz (cm) → braucht zusätzlichen Spielraum, Objekt sitzt höher.
  function nestRise(L, U, off) {
    var lo = pf(L), up = pf(U), pad = -0.15 + (off || 0);   // negativ = etwas tieferes Einsinken
    if (!lo.hasInner) return fH(L);                            // Teller: oben drauf
    var loOpen = geo(L).innerR;                               // ENGSTE Stelle = L's Öffnung (Rand-Innenradius)
    var dMin = lo.floorY, dMax = lo.yr + 1, step = 0.05;
    for (var d = dMin; d <= dMax; d += step) {
      var ok = true;
      for (var t = 0; t <= up.yr; t += Math.max(0.06, up.yr/22)) {
        var yA = d + t; if (yA >= lo.yr) break;                // über L's Rand → frei
        // Jeder Teil von U, der unter L's Rand sitzt, MUSSTE durch L's Öffnung passen: U's breiteste
        // Stelle ≤ Öffnung (nicht nur ≤ Innenwand — die ist beim bauchigen Träger weiter). Sonst sitzt U
        // mit dem Bauch auf der Öffnung auf (perch), statt unrealistisch durchzuschlüpfen.
        if (up.ro(t) > loOpen - pad || up.ro(t) > lo.ri(yA) - pad) { ok = false; break; }
      }
      if (ok) return d;
    }
    return dMax;
  }

  function vesselSVG(sh, color, emph, ground, opts) {
    color = color || GLAZES[0].rgb;
    var g = geo(sh);
    var ro = g.ro*S, yr = g.yr*S, roy = ro*K;                 // Außenrand (px)
    var ir = g.innerR*S, iry = ir*K;                          // Innenrand / Öffnung (px)
    var baseR = g.baseR*S, baseRy = baseR*K;
    var raw = !!(opts && opts.rawOutside), outColor = raw ? RAW_CLAY : color;   // außen roh vs glasiert
    var LW = 1.1, line = 'rgba(var(--color-foreground),0.55)', fill = 'rgb('+lighten(outColor, 0.06)+')', nss = ' vector-effect="non-scaling-stroke"';
    // ECHTER Rotationskörper: Querschnitt axial gedreht + projiziert.
    // Profil dicht in Höhenscheiben resampeln; jede Scheibe projiziert als Ellipse
    // (rx = r, ry = r·K); der Körper = Vereinigung der Scheiben. Silhouette = oberer/
    // unterer Rand der Vereinigung pro Bildspalte. Eine Logik für ALLE Formen —
    // keine Sonderfälle, keine handgebauten Bögen.
    var sl = [];                                             // [cy, r] je Scheibe (px)
    for (var si = 0; si < g.o.length - 1; si++) {
      var pa = g.o[si], pb = g.o[si+1];
      var seg = Math.max(1, Math.ceil(Math.abs(pb[1] - pa[1]) / 0.08));
      for (var st = 0; st < seg; st++) { var u = st / seg; sl.push([-(pa[1] + (pb[1]-pa[1])*u) * S, (pa[0] + (pb[0]-pa[0])*u) * S]); }
    }
    sl.push([-yr, ro]);
    var rb = g.maxR * S, NX = Math.max(6, Math.ceil(rb / 1.5)), xs = [], tp = [], bp = [];
    for (var xk = 0; xk <= NX; xk++) {
      var x = rb * xk / NX, hi = -1e9, lo = 1e9;
      for (var s2 = 0; s2 < sl.length; s2++) {
        var rp = sl[s2][1]; if (rp < x - 0.01) continue;      // Epsilon: Float-Rundung an der äußersten Spalte
        var e = K * Math.sqrt(Math.max(0, rp*rp - x*x)), cyl = sl[s2][0];
        if (cyl + e > hi) hi = cyl + e;
        if (cyl - e < lo) lo = cyl - e;
      }
      if (hi < -1e8) continue;                                // leere Spalte nie in den Pfad
      xs.push(x); bp.push(hi); tp.push(lo);
    }
    var P2 = function (px2, py2) { return px2.toFixed(1)+' '+py2.toFixed(1); };
    var pth = [], NL = xs.length - 1;
    for (var q1 = NL; q1 >= 1; q1--) pth.push(P2(-xs[q1], bp[q1]));   // Unterkante links…
    for (var q2 = 0; q2 <= NL; q2++)  pth.push(P2(xs[q2], bp[q2]));   // …nach rechts
    for (var q3 = NL - 1; q3 >= 0; q3--) pth.push(P2(xs[q3], tp[q3])); // Oberkante rechts…
    for (var q4 = 1; q4 <= NL; q4++)  pth.push(P2(-xs[q4], tp[q4]));  // …nach links
    var body = 'M '+pth[0]+' '+pth.slice(1).map(function (p) { return 'L '+p; }).join(' ')+' Z';
    var ocO = 'cx="0" cy="'+(-yr).toFixed(1)+'" rx="'+ro.toFixed(1)+'" ry="'+roy.toFixed(1)+'"';   // Außen-Ellipse
    var ocI = 'cx="0" cy="'+(-yr).toFixed(1)+'" rx="'+ir.toFixed(1)+'" ry="'+iry.toFixed(1)+'"';   // Öffnung
    // Rand-Oberfläche (Materialstärke-Ring) IMMER mit Glasur füllen — nie der Bone-Hintergrund
    // (sonst „weißer Trinkrand"). Kavität darüber leicht getönt = Tiefe.
    var inTint = darken(color, g.plate ? 0.96 : 0.9);
    var rimTop = '<ellipse '+ocO+' fill="'+fill+'"/>';
    var cavity = '<ellipse '+ocI+' fill="rgb('+inTint+')"/>';
    var rimLines = '<ellipse '+ocO+' fill="none" stroke="'+line+'" stroke-width="'+LW+'"'+nss+'/><ellipse '+ocI+' fill="none" stroke="'+line+'" stroke-width="'+LW+'"'+nss+'/>';
    // Kante = schärfster Knick der Außenkontur (Edge: Bauch; Bevel: Mitte ~0.24 rad).
    // Special glatt → keine. Fußzone ausklammern (kein Phantom-Absatz unten).
    var bi = -1, best = 0.2, O = g.o;
    for (var ci = 1; ci < O.length - 1; ci++) {
      if (O[ci][1] < g.yr * 0.12) continue;
      var a0 = Math.atan2(O[ci][1]-O[ci-1][1], O[ci][0]-O[ci-1][0]);
      var a1 = Math.atan2(O[ci+1][1]-O[ci][1], O[ci+1][0]-O[ci][0]);
      var turn = Math.abs(a1 - a0); if (turn > Math.PI) turn = 2*Math.PI - turn;
      if (turn > best) { best = turn; bi = ci; }
    }
    var ridge = '';
    if (bi > 0) { var br = O[bi][0]*S, by = -O[bi][1]*S, bry = br*K;
      ridge = '<path d="M '+(-br).toFixed(1)+' '+by.toFixed(1)+' A '+br.toFixed(1)+' '+bry.toFixed(1)+' 0 0 0 '+br.toFixed(1)+' '+by.toFixed(1)+'" fill="none" stroke="'+line+'" stroke-width="'+LW+'"'+nss+'/>'; }
    var sid = 'sh' + (UID++);
    var shadow = ground ? '<radialGradient id="'+sid+'"><stop offset="0" stop-color="rgba(var(--color-foreground),0.22)"/><stop offset="60%" stop-color="rgba(var(--color-foreground),0.08)"/><stop offset="100%" stop-color="rgba(var(--color-foreground),0)"/></radialGradient><ellipse cx="0" cy="'+(baseRy*0.7).toFixed(1)+'" rx="'+(baseR*1.35).toFixed(1)+'" ry="'+(baseRy*1.0).toFixed(1)+'" fill="url(#'+sid+')"/>' : '';
    var w = g.maxR*S*2+8, hgt = yr+roy+baseRy*2.1+8, minx = -w/2, miny = -yr-roy-4;
    var solid = '<path d="'+body+'" fill="'+fill+'" stroke="'+line+'" stroke-width="'+LW+'" stroke-linejoin="round"'+nss+' style="transition:fill var(--dur-fast,.2s) var(--ease,ease)"/>';
    // Brush-Glasur: Vektor-Pinselstrich auf die Wölbung gebogen. Heller + halbtransparent
    // (Konturen scheinen durch), 1.5× skaliert, Lage stark gestreut (läuft teils über den Rand).
    var brush = '', contourTop = '';
    if (opts && opts.brush && PINSEL.length) {
      var seed = opts.seed || '';
      var V = PINSEL[Math.floor(hstr(seed + 'var') * PINSEL.length) % PINSEL.length];
      var bandFrac = 0.4 + hstr(seed + 'v') * 0.12, h0 = g.yr * bandFrac;
      var roAt = function (y) { var o = g.o; for (var k = 1; k < o.length; k++) { if (o[k][1] >= y) { var a = o[k-1], b = o[k], t = (y-a[1]) / ((b[1]-a[1]) || 1); return a[0] + (b[0]-a[0]) * t; } } return o[o.length-1][0]; };
      var r0 = roAt(h0) * S, thick = Math.max(g.yr * 0.45, 3) * S;
      var phiC = (hstr(seed) * 2 - 1) * 55, span = 150, D = Math.PI / 180;
      var mapf = function (px, py) {
        var u = (px - V.x0) / ((V.x1 - V.x0) || 1), vv = (py - V.ymid) / V.halfH;
        var phi = (phiC + (u - 0.5) * span) * D;
        return (r0 * Math.sin(phi)).toFixed(2) + ',' + (-h0 * S + K * r0 * Math.cos(phi) + vv * thick * 0.5).toFixed(2);
      };
      var tpB = V.paths.map(function (d) { return '<path d="' + d.replace(/(-?\d+\.?\d*),(-?\d+\.?\d*)/g, function (_, a, b) { return mapf(+a, +b); }) + '"/>'; }).join('');
      var bcid = 'bc' + (UID++);
      brush = '<clipPath id="'+bcid+'"><path d="'+body+'"/></clipPath><g clip-path="url(#'+bcid+')" fill="rgba(var(--color-foreground),0.72)">' + tpB + '</g>';
      contourTop = '<path d="'+body+'" fill="none" stroke="'+line+'" stroke-width="'+LW+'" stroke-linejoin="round"'+nss+'/>';   // Kontur über den Strich
    }
    // Schimmer + Glanz, beide skaliert mit dem Glasur-Shine (0 = unglasiert/roh: nichts davon).
    var SHN = raw ? 0 : (opts && opts.shine != null ? opts.shine : 0.4);   // roh außen → kein Schimmer/Glanz
    var sheen = '', WARM = '255,244,224';                        // warmer Schimmer-Ton (statt reinweiß)
    if (SHN > 0.02) {
      var a1 = (0.30 * Math.min(1, SHN / 0.4)).toFixed(3);       // diffuser Schimmer (wie bisher bei 0.4)
      var gid = 'gl' + (UID++);
      sheen = '<linearGradient id="'+gid+'" x1="0.12" y1="0" x2="0.78" y2="1">'+
        '<stop offset="0" stop-color="rgba('+WARM+','+a1+')"/>'+
        '<stop offset="0.5" stop-color="rgba('+WARM+','+(a1*0.3).toFixed(3)+')"/>'+
        '<stop offset="0.85" stop-color="rgba('+WARM+',0)"/></linearGradient>'+
        '<path d="'+body+'" fill="url(#'+gid+')"/>';
      // Breiter, weicher Glanz-Streif (Glasur-Reflex) auf der linken Wölbung — ab mittlerem Shine.
      var glossA = Math.max(0, SHN - 0.2) * 0.6;
      if (glossA > 0.01) {
        var hid = 'hl' + (UID++), hcx = (-g.ro * S * 0.42).toFixed(1), hcy = (-g.yr * S * 0.5).toFixed(1);
        var hrx = (g.ro * S * 0.34).toFixed(1), hry = (g.yr * S * 0.5).toFixed(1);
        sheen += '<radialGradient id="'+hid+'"><stop offset="0" stop-color="rgba('+WARM+','+glossA.toFixed(3)+')"/><stop offset="55%" stop-color="rgba('+WARM+','+(glossA*0.4).toFixed(3)+')"/><stop offset="100%" stop-color="rgba('+WARM+',0)"/></radialGradient>'+
          '<clipPath id="'+hid+'c"><path d="'+body+'"/></clipPath>'+
          '<g clip-path="url(#'+hid+'c)"><ellipse cx="'+hcx+'" cy="'+hcy+'" rx="'+hrx+'" ry="'+hry+'" fill="url(#'+hid+')"/></g>';
      }
    }
    // gestrichelte Kontur für verdeckte Stapel-Teile
    var dash = '<path d="'+body+'" fill="none" stroke="'+line+'" stroke-width="'+LW+'" stroke-dasharray="3 3"'+nss+'/><ellipse '+ocO+' fill="none" stroke="'+line+'" stroke-width="'+LW+'" stroke-dasharray="3 3"'+nss+'/>';
    // Vorderwand-Mitte (Öffnungsellipse ausgenommen): Mitte zwischen vorderer Öffnungskante (-yr+roy) und Fuß (+baseRy).
    return { w:w, h:hgt, minx:minx, miny:miny, cy:(-yr + roy + baseRy) / 2, body:body, dash:dash, svg: shadow + solid + sheen + brush + contourTop + rimTop + cavity + rimLines + ridge, geo:g };
  }
  function art(sh, color, boxH) {
    var v = vesselSVG(sh, color);
    return '<svg viewBox="'+v.minx.toFixed(1)+' '+v.miny.toFixed(1)+' '+v.w.toFixed(1)+' '+v.h.toFixed(1)+'" width="'+v.w.toFixed(0)+'" height="'+v.h.toFixed(0)+'" style="max-height:'+(boxH||56)+'px;max-width:100%">'+v.svg+'</svg>';
  }
  function cat(it) { return TYPES[it.t].typ.charAt(0); }  // C / B / P

  var sel = [], active = -1, gGlaze = 0, gNest = true, stageAnim = null, stageSolid = false, settleTimer = null;   // stageAnim: 'add'|'toggle'|null
  var dispNest = true;                                        // aktuell GEZEIGTER Nest-Zustand (temporär entkoppelt von gNest beim Antippen)
  var delIdx = -1, delTimer = null;                          // Objekt angetippt → ×-Button darauf, blendet nach ~2.6s aus
  var ghostTimer = null, ghostA = 0;                         // Leerzustand: morphende Geister-Artikel im 5:7-Rahmen
  var money = function (v) { return (v % 1 === 0 ? v : v.toFixed(2)) + ' €'; };

  // Gemeinsamer Maßstab für Picker-Thumbnails → echte Größenverhältnisse (Espresso klein, Serving groß).
  var GVB = (function () {
    var mw = 0, mh = 0;
    TYPES.forEach(function (t) { t.forms.forEach(function (f) { mw = Math.max(mw, fMaxR(f) * S); mh = Math.max(mh, fH(f) * S); }); });
    var pad = 6, ry = mw * K;
    return { x: -(mw + pad), w: (mw + pad) * 2, y: -(mh + ry + pad), h: mh + ry + pad + (ry * 1.7 + pad) };
  })();
  function artFixed(sh, color, opts) {
    var v = vesselSVG(sh, color, false, true, opts);
    return '<svg viewBox="' + GVB.x.toFixed(1) + ' ' + GVB.y.toFixed(1) + ' ' + GVB.w.toFixed(1) + ' ' + GVB.h.toFixed(1) + '" width="100%" height="100%" preserveAspectRatio="xMidYMax meet">' + v.svg + '</svg>';
  }
  function typeFormIndex(t, form) { for (var i = 0; i < t.forms.length; i++) { if (t.forms[i].form === form) return i; } return -1; }
  // FORM ZUERST: Selektor Edge/Bevel/Special
  function renderFormSel() {
    var el = $('[data-formsel]'); if (!el) return;
    el.innerHTML = AVAILFORMS.map(function (f) { return '<button data-f="' + f + '" aria-pressed="' + (f === gForm) + '">' + f + '</button>'; }).join('');
    el.querySelectorAll('button').forEach(function (b) { b.onclick = function () {
      gForm = b.dataset.f;
      if (!glazeOK(gGlaze)) { for (var gi = 0; gi < GLAZES.length; gi++) if (glazeOK(gi)) { gGlaze = gi; break; } }
      renderFormSel(); renderGlazeSel(); renderPicker();
    }; });
  }
  // Mini-Pinselstrich fürs Brush-Swatch (Engobe-Ton wie am Gefäß): dicker Mittelstrich + zwei Bristle-Streifen.
  function brushIcon(rgb) {
    // Runder Swatch wie die Punkte (nicht verzogen); Pinselstrich sitzt IM Kreis (überstand geclippt).
    return '<span class="setcfg__glz-brush" style="background:rgb('+rgb+')" aria-hidden="true"><svg viewBox="0 0 12 12">'+
      '<g fill="none" stroke="rgba(var(--color-foreground),0.8)" stroke-linecap="round">'+
        '<path d="M1.6 7.4 C4 5 8 5.2 10.4 6.6" stroke-width="2.4"/>'+
        '<path d="M2.6 9 C5 8.5 8 8.6 9.8 8.2" stroke-width="0.8" stroke-opacity="0.5"/>'+
      '</g></svg></span>';
  }
  // DANN Glasur wählen (global) — nur Glasuren, die für die aktuelle Form gelten
  function renderGlazeSel() {
    var el = $('[data-glazesel]'); if (!el) return;
    el.innerHTML = GLAZES.map(function (g, gi) { return glazeOK(gi)
      ? '<button class="setcfg__glz'+(gi===gGlaze?' is-on':'')+'" data-g="'+gi+'">'+(isBrush(gi) ? brushIcon(g.rgb) : '<span class="setcfg__glz-dot" style="background:rgb('+g.rgb+')"></span>')+g.name+'</button>'
      : ''; }).join('');
    el.querySelectorAll('button').forEach(function (b) { b.onclick = function () { gGlaze = +b.dataset.g; renderGlazeSel(); renderPicker(); }; });
  }
  // DANN alle Typen (Cups | Bowls | Plates) in der gewählten Form + Glasur — Karten wie Kollektion (5:7)
  function renderPicker() {
    var el = $('[data-picker]'), color = GLAZES[gGlaze].rgb;
    // Eine Karte je Typ (oder '' wenn Form/Glasur nicht verfügbar)
    function card(t, i) {
      var fi = typeFormIndex(t, gForm); if (fi < 0) return '';
      if (t.glazes.indexOf(GLAZES[gGlaze].name) < 0) return '';   // Typ bietet die gewählte Glasur nicht → nicht anbieten
      var f = t.forms[fi];
      var cnt = sel.reduce(function (s, it) { return s + (it.t === i && it.form === fi && it.g === gGlaze ? 1 : 0); }, 0);   // wie viele von GENAU diesem Objekt (Typ×Form×Glasur) im Set — der Badge sitzt auf dem gefaerbten Objekt, muss also die Glasur mitzaehlen (Folke 2026-07-16)
      var ml = (SPECS[f.code] && SPECS[f.code].cap) ? SPECS[f.code].cap : '';   // Füllmenge oben rechts (Folke 2026-07-14)
      var art = artFixed(f, color, { brush: isBrush(gGlaze), seed: f.code, shine: glazeShine(gGlaze), rawOutside: t.ni });
      if (cnt) {
        // Zähler dynamisch an die Objekt-Oberkante rechts pinnen (SVG-Badge im Bild, Folke 2026-07-15).
        var gB = geo(f), roS = gB.ro * S, byTop = -(gB.yr * S + roS * K * 0.2), bx = (roS * 0.9).toFixed(1), by = byTop.toFixed(1);
        var badge = '<g aria-label="'+cnt+' im Set">' +
          '<circle cx="'+bx+'" cy="'+by+'" r="18" fill="rgb(var(--color-foreground))" stroke="rgb(var(--color-background))" stroke-width="1.5" vector-effect="non-scaling-stroke"/>' +
          '<text x="'+bx+'" y="'+by+'" text-anchor="middle" dominant-baseline="central" fill="rgb(var(--color-background))" font-size="21" style="font-family:var(--font-body-family)">'+cnt+'</text></g>';
        art = art.replace('</svg>', badge + '</svg>');
      }
      return '<button class="setcfg__pk" data-i="'+i+'" data-fi="'+fi+'">' +
        (ml ? '<span class="setcfg__pk-ml">'+ml+'</span>' : '') +
        '<span class="setcfg__pk-name">'+t.name+'</span>' +
        '<span class="setcfg__pa">'+art+'</span>' +
        '<span class="setcfg__pk-foot"><span>'+f.code+'</span><span>'+t.price+' EUR</span></span>' +
        '</button>';
    }
    // Nach Art gruppiert (Cups | Bowls | Plates). Auf Mobil je Gruppe eine horizontale Scroll-Reihe
    // (spart Platz, weniger vertikales Scrollen — Folke 2026-07-16).
    var CATN = { C: 'Cups', B: 'Bowls', P: 'Plates' };
    // Horizontale Scroll-Position je Reihe merken: renderPicker läuft nach jedem Add, sonst springt die
    // Reihe zurück auf 0 (Folke 2026-07-16). Vor dem Neuaufbau sichern, danach wiederherstellen.
    var scrollMem = {};
    el.querySelectorAll('.setcfg__pkrow').forEach(function (r) { scrollMem[r.getAttribute('data-cat')] = r.scrollLeft; });
    el.innerHTML = ['C', 'B', 'P'].map(function (ck) {
      var cards = TYPES.map(function (t, i) { return ('' + t.typ).charAt(0) === ck ? card(t, i) : ''; }).join('');
      if (cards.indexOf('setcfg__pk') < 0) return '';           // leere Kategorie überspringen
      return '<div class="setcfg__pkgroup"><div class="setcfg__pkgroup-h">'+CATN[ck]+'</div><div class="setcfg__pkrow" data-cat="'+ck+'">'+cards+'</div></div>';
    }).join('');
    el.querySelectorAll('.setcfg__pkrow').forEach(function (r) { var s = scrollMem[r.getAttribute('data-cat')]; if (s) r.scrollLeft = s; });
    el.querySelectorAll('.setcfg__pk').forEach(function (b) { b.onclick = function () {
      if (sel.length >= MAX) return;
      if (delTimer) { clearTimeout(delTimer); delTimer = null; } delIdx = -1; dispNest = gNest;
      var wasEmpty = !sel.length;
      sel.push({ t: +b.dataset.i, form: +b.dataset.fi, g: gGlaze, id: UID++ }); active = sel.length - 1;
      if (wasEmpty) ghostToStack(); else render(true);
    }; });
  }
  // Ein gruppierter Stapel (größte unten). Regeln:
  // - Kleinere sinken geometrisch in größere (nestRise).
  // - Würde ein Objekt dabei (fast) komplett verschwinden → eigene Säule DANEBEN.
  // - Drei Sicht-Zonen pro genestetem Objekt: über dem Rand = solid; in der Öffnung
  //   sichtbar = abgedunkelt (Multiply-Look, deterministisch statt Blendmode);
  //   hinter der Wand = gestrichelt. Maske trennt sauber — keine Doppelzeichnung.
  function buildGroup(items) {
    var order = items.slice().sort(function (a, b) { return fMaxR(b.p) - fMaxR(a.p); });
    var cols = [];
    var COLCAP = 5;                                              // max Teile je Säule → sonst neue daneben
    // Nest-Logik (Folke 2026-07-16): ein Stück nestet nur, wenn es WIRKLICH passt. Sonst daneben.
    //  1. Passt nicht rein (breiteste Stelle > Öffnung des Trägers) → nicht nesten (Ausnahme: gleiches
    //     Objekt darf aufeinander stapeln).
    //  2. Würde es >85% verdeckt (sichtbarer Anteil über dem Trägerrand < 15% der Eigenhöhe) → daneben.
    // Reihenfolge groß→klein: o ist nie breiter als der Träger. Kein künstlicher Peek mehr — physische Tiefe.
    order.forEach(function (o) {
      var hO = fH(o.p), rMax = fMaxR(o.p);
      for (var c = 0; c < cols.length; c++) {
        if (cols[c].length >= COLCAP) continue;                  // Säule voll → nächste probieren
        var top = cols[c][cols[c].length - 1];
        var same = (o.it.t === top.it.t && o.it.form === top.it.form);   // gleiches Objekt (Typ×Form)
        var fitsInside = rMax <= geo(top.p).innerR + 0.15;       // breiteste Stelle ≤ Öffnung (+ 0.15 Spiel)
        if (!fitsInside && !same) continue;                      // passt nicht rein & nicht gleich → nicht hier
        var d = nestRise(top.p, o.p);
        var protr = d + hO - fH(top.p);                          // sichtbarer Anteil über dem Trägerrand
        if (protr < 0.15 * hO) continue;                         // >85% verdeckt → nicht hier (daneben)
        o._d = d; cols[c].push(o); return;
      }
      o._d = 0; cols.push([o]);                                  // eigene Säule daneben
    });
    var parts = [], colX = 0, gapC = 14, nMiny = 0, nMaxSB = 0, eMiny = 0, eMaxSB = 0;   // Extents je Lage (buildGroup-weit)
    cols.forEach(function (col) {
      var halfW = 0, nestedY = 0, explodedY = 0;                // je Spalte zurückgesetzt
      col.forEach(function (o) { halfW = Math.max(halfW, fMaxR(o.p) * S + 4); });
      var cx = colX + halfW;
      col.forEach(function (o, k) {
        var v = vesselSVG(o.p, GLAZES[o.it.g].rgb, o.idx === active, k === 0, { brush: isBrush(o.it.g), seed: 's' + (o.it.id != null ? o.it.id : o.idx), shine: glazeShine(o.it.g), rawOutside: TYPES[o.it.t] && TYPES[o.it.t].ni });
        var body = v.svg, clipOpen = '', clipClose = '', edge = '', dash = '';
        if (k > 0) {
          nestedY -= o._d * S;                                  // genestet: einsinken (nestRise-Tiefe)
          // Explodiert (nicht genestet): Stücke getrennt mit GANZ LEICHTEM Spalt (Folke 2026-07-16) —
          // Fuß knapp über dem Trägerrand (+ halbe Rand-Ellipse, damit die Ringe sich nicht überlappen)
          // + schmaler Luftspalt. Kein Überlappen, aber nur ein Hauch Abstand.
          var gP = geo(col[k-1].p);
          explodedY -= (gP.yr + gP.ro * K * 0.5) * S + 6;
        }
        // Während der Toggle-Bewegung (stageSolid) IMMER genestet zeichnen (Clip vorhanden),
        // damit Off exakt die Umkehr von On ist: Objekt gleitet hinter dem Elternrand heraus.
        var nestedMode = dispNest || stageSolid;
        var baseY = nestedMode ? nestedY : explodedY, altY = nestedMode ? explodedY : nestedY;
        if (k > 0 && nestedMode) {
          var L = col[k-1].p, cutCm = fH(L) - o._d;
          if (cutCm > 0.05) {
            var gL = geo(L), irF = gL.innerR * S, iryF = irF * K, id = UID++;
            // Verdeckungsgrenze = vorderer Öffnungsbogen des unteren Objekts. Der Clip ist
            // STATISCH am Elternrand (umschließt die Animation): das Objekt gleitet dahinter,
            // sein unterer Teil verschwindet korrekt hinter dem Elternobjekt (nie davor).
            var cy = (-cutCm * S).toFixed(1), rF = irF.toFixed(1), ryF = iryF.toFixed(1);
            var x0 = (-irF).toFixed(1), x1 = irF.toFixed(1);
            var arc = 'L '+x0+' '+cy+' A '+rF+' '+ryF+' 0 0 0 '+x1+' '+cy+' L 9999 '+cy;
            clipOpen = '<clipPath id="ca'+id+'"><path d="M -9999 '+cy+' '+arc+' L 9999 -9999 L -9999 -9999 Z"/></clipPath><g clip-path="url(#ca'+id+')">';
            clipClose = '</g>';
            // edge/dash sind Ruhezustand-Deko; während der Bewegung (stageSolid) weglassen, sonst
            // bleibt der statische Randbogen als freischwebende Linie zurück. Settle zeichnet sie sauber.
            if (!stageSolid) {
              edge = '<path d="M '+x0+' '+cy+' A '+rF+' '+ryF+' 0 0 0 '+x1+' '+cy+'" fill="none" stroke="rgba(var(--color-foreground),0.55)" stroke-width="1.1" vector-effect="non-scaling-stroke"/>';
              dash = '<clipPath id="cb'+id+'"><path d="M -9999 '+cy+' '+arc+' L 9999 9999 L -9999 9999 Z"/></clipPath><g clip-path="url(#cb'+id+')">' + v.dash + '</g>';
            }
          }
        }
        parts.push({ x: cx, y: baseY, yAlt: altY, cy: v.cy, body: body, clipOpen: clipOpen, clipClose: clipClose, edge: edge, dash: dash, idx: o.idx, depth: k });
        // Extents für BEIDE Lagen getrennt: der Rahmen fasst jede Lage eng (kein Weißraum), der Maßstab
        // wird aber aus der höheren (explodierten) Lage abgeleitet → beide Lagen gleicher Maßstab, kein
        // Größensprung beim Toggle. nestedY/explodedY sind hier die Position dieses Stücks je Lage.
        nMiny = Math.min(nMiny, nestedY + v.miny);
        eMiny = Math.min(eMiny, explodedY + v.miny);
        if (k === 0) { var sb = v.geo.baseR * S * K * 1.85; nMaxSB = Math.max(nMaxSB, nestedY + sb); eMaxSB = Math.max(eMaxSB, explodedY + sb); }
      });
      colX += halfW * 2 + gapC;
    });
    return { parts: parts, minx: 0, maxx: colX - gapC, nMiny: nMiny, nMaxy: nMaxSB, eMiny: eMiny, eMaxy: eMaxSB };
  }
  // 5:7-Produktrahmen: konstante Objektskala, Bühne wächst mit dem Inhalt (dynamischer Weißraum);
  // Einzelobjekt sitzt portrait gerahmt wie ein Produktbild. Verkleinert erst, wenn Breite/Höhe das Limit sprengt.
  function stageFrame(vw, vh) {
    var stage = $('[data-stage]');
    var availW = stage.clientWidth || (stage.parentElement && stage.parentElement.clientWidth) || 460;
    var maxH = Math.min((window.innerHeight || 800) * 0.78, 660);
    var F = Math.min(2.9, availW / vw);
    var oWpx = vw * F, oHpx = vh * F;
    if (oHpx > maxH) { F *= maxH / oHpx; oWpx = vw * F; oHpx = vh * F; }
    var frameH = Math.min(Math.max(oHpx, oWpx * 7 / 5), maxH);
    return { oWpx: Math.round(oWpx), oHpx: Math.round(oHpx), frameH: Math.round(frameH) };
  }
  function renderStage(justAdded, fadeDashed) {
    var stage = $('[data-stage]');
    root.classList.toggle('setcfg--live', sel.length > 0);
    if (!sel.length) { renderGhost(); return; }               // Leer: 5:7-Rahmen mit morphenden Geister-Artikeln
    clearGhost();
    var animEarly = reduced() ? null : (stageAnim || (justAdded ? 'add' : null));
    stageSolid = (animEarly === 'toggle');                       // Toggle-Bewegung: solide zeichnen, danach settlen
    // Gleiche Gruppierung in beiden Modi; buildGroup entscheidet über die Sitz-/Schwebe-Höhe.
    var CATS = [['C','B'],['P']], gap = 22, running = 0, placed = [], gNMiny = 0, gNMaxY = 0, gEMiny = 0, gEMaxY = 0;
    CATS.forEach(function (cs) {
      var items = sel.map(function (it, idx) { return { it: it, idx: idx, p: formOf(it) }; }).filter(function (o) { return cs.indexOf(cat(o.it)) >= 0; });
      if (!items.length) return;
      var g = buildGroup(items);
      var dx = running - g.minx;           // linke Kante der Gruppe an running
      placed.push({ g: g, dx: dx });
      running += (g.maxx - g.minx) + gap;
      gNMiny = Math.min(gNMiny, g.nMiny); gNMaxY = Math.max(gNMaxY, g.nMaxy);   // Extents genestet
      gEMiny = Math.min(gEMiny, g.eMiny); gEMaxY = Math.max(gEMaxY, g.eMaxy);   // Extents explodiert
    });
    var totalW = running - gap;
    var shift = -totalW / 2;
    var anim = animEarly, svg, toggleTotal = 600;
    // EINE Struktur für Bewegung UND Ruhe: immer mit Verdeckungs-Clip am Elternrand. Der Körper gleitet
    // per FLIP durch den STATISCHEN Clip — beim Explodieren steigt er über die Clip-Linie und wird sauber
    // freigelegt, beim Nesten sinkt er dahinter. So ist die Verdeckung während der Bewegung identisch zum
    // Ruhezustand → kein Umspringen von „vorne/hinten" beim Ein-/Aussteigen. Deko (Randbogen/gestrichelt)
    // gibt es nur im Ruhezustand (buildGroup lässt sie bei stageSolid weg) und blendet am Ende weich ein.
    svg = placed.map(function (P) {
      var ox = (P.dx + shift).toFixed(1);
      return '<g transform="translate('+ox+' 0)">' +
        P.g.parts.map(function (pt) {
          var attr = '';
          if (anim === 'toggle') attr = ' data-mv="'+(pt.yAlt - pt.y).toFixed(1)+'" data-depth="'+(pt.depth || 0)+'"';
          else if (anim === 'add' && pt.idx === active) attr = ' data-drop="1"';
          var edgeMk = pt.edge ? ((fadeDashed && !reduced()) ? '<g style="animation:setcfgFade var(--dur-base,.3s) var(--ease,ease) both">'+pt.edge+'</g>' : pt.edge) : '';
          return '<g class="setcfg__ves" data-idx="'+pt.idx+'" data-cy="'+pt.cy.toFixed(1)+'" transform="translate('+pt.x.toFixed(1)+' '+pt.y.toFixed(1)+')">'+
            pt.clipOpen+'<g class="setcfg__ves-anim"'+attr+'>'+pt.body+'</g>'+pt.clipClose+edgeMk+'</g>';
        }).join('') +
        P.g.parts.map(function (pt) { return pt.dash ? '<g transform="translate('+pt.x.toFixed(1)+' '+pt.y.toFixed(1)+')"'+(fadeDashed && !reduced() ? ' style="animation:setcfgFade var(--dur-base,.3s) var(--ease,ease) both"' : '')+'>'+pt.dash+'</g>' : ''; }).join('') +
        '</g>';
    }).join('');
    // Maßstab F aus der EXPLODIERTEN (höheren) Lage → sie passt ins Höhen-Limit; DERSELBE F für beide
    // Lagen = kein Größensprung beim Toggle. Gerahmt wird die AKTUELLE Lage eng (kein Weißraum); während
    // der Bewegung die Vereinigung, damit die steigenden Stücke nicht abgeschnitten werden.
    var vx = shift - 8, vw = totalW + 16;
    var eVh = (gEMaxY - gEMiny) + 34;
    var F = stageFrame(vw, eVh).oWpx / vw;                    // konstanter Maßstab (Klammer maxH steckt in stageFrame)
    var cMiny = stageSolid ? Math.min(gNMiny, gEMiny) : (dispNest ? gNMiny : gEMiny);
    var cMaxy = stageSolid ? Math.max(gNMaxY, gEMaxY) : (dispNest ? gNMaxY : gEMaxY);
    var vy = cMiny - 14, vh = (cMaxy - cMiny) + 42;   // CUSTOM (Folke 2026-07-17): mehr Luft oben/unten, damit der Boden-Schatten beim Zoom-Transient nie an der Rahmenkante sitzt
    var oWpx = Math.round(vw * F), oHpx = Math.round(vh * F);
    stage.style.height = oHpx + 'px';
    stage.innerHTML = '<svg viewBox="'+vx.toFixed(1)+' '+vy.toFixed(1)+' '+vw.toFixed(1)+' '+vh.toFixed(1)+'" width="'+oWpx+'" height="'+oHpx+'" preserveAspectRatio="xMidYMid meet">'+svg+'</svg>';
    stage.querySelectorAll('.setcfg__ves').forEach(function (g) { g.style.cursor='pointer'; g.onclick = function () {
      var idx = +g.dataset.idx;
      active = idx; delIdx = idx;
      if (gNest && dispNest) { dispNest = false; stageAnim = 'toggle'; }   // temporär explodieren → × liegt frei
      if (delTimer) clearTimeout(delTimer);
      delTimer = setTimeout(hideDel, 2600);
      render();
    }; });
    // FLIP: Startposition SOFORT setzen (erstes Bild = getrennte Lage, kein Aufblitzen an der
    // Zielposition), Reflow erzwingen, dann per Transition an den Platz gleiten lassen.
    if (!reduced() && anim === 'toggle') {
      var mvEls = stage.querySelectorAll('.setcfg__ves-anim[data-mv]');
      // Nesten (On): explodiert → genestet, endet bei 0. Explodieren (Off): genestet(0) → explodiert(mv),
      // gleitet hinter dem Elternkörper heraus (Maler-Reihenfolge = Verdeckung, sichtbares Sinken).
      // GESTAFFELT: pro Stapelebene ein kleiner Versatz → Kaskade statt Block. Dauer/Delay in JS
      // fixiert (nicht var-abhängig), damit der Settle exakt nach der letzten Bewegung greift (kein Snap).
      var expanding = !dispNest, DUR = 520, STEP = 60, maxD = 0;
      mvEls.forEach(function (el) { maxD = Math.max(maxD, +el.getAttribute('data-depth') || 0); });
      mvEls.forEach(function (el) { el.style.transform = 'translateY(' + (expanding ? '0px' : el.getAttribute('data-mv') + 'px') + ')'; });
      void stage.getBoundingClientRect().width;
      requestAnimationFrame(function () {
        mvEls.forEach(function (el) {
          var dp = +el.getAttribute('data-depth') || 0;
          var delay = Math.max(0, (expanding ? (maxD - dp) : (dp - 1)) * STEP);   // Explodieren: oben zuerst · Nesten: unten zuerst
          el.style.transition = 'transform ' + DUR + 'ms var(--ease,ease) ' + delay + 'ms';
          el.style.transform = 'translateY(' + (expanding ? el.getAttribute('data-mv') + 'px' : '0') + ')';
        });
      });
      toggleTotal = DUR + maxD * STEP + 70;   // Settle erst, wenn die letzte gestaffelte Bewegung steht
    } else if (!reduced() && anim === 'add') {
      var dropEl = stage.querySelector('.setcfg__ves-anim[data-drop]');
      if (dropEl) {
        dropEl.style.transform = 'translateY(-70px)'; dropEl.style.opacity = '0';
        void stage.getBoundingClientRect().width;
        requestAnimationFrame(function () { dropEl.style.transition = 'transform var(--dur-slow,.55s) cubic-bezier(.34,1.15,.6,1), opacity var(--dur-base,.3s) var(--ease,ease)'; dropEl.style.transform = 'translateY(0)'; dropEl.style.opacity = '1'; });
      }
    }
    // Nach der Toggle-Bewegung einmal sauber neu zeichnen (verdeckte Linien/Cut am Zielort).
    // Nur der jüngste Settle läuft (verhindert überlappende Re-Renders bei schnellem Toggeln).
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
    if (anim === 'toggle') settleTimer = setTimeout(function () { settleTimer = null; renderStage(false, dispNest); placeDelBtn(false); }, toggleTotal);
    stageAnim = null; stageSolid = false;
    placeDelBtn(anim === 'toggle');                            // beim Explodieren synchron mitgleiten, sonst direkt setzen
  }
  // Leerzustand: 5:7-Rahmen mit faintem Geister-Gefäß, das ECHT morpht. Für saubere (nicht zackige)
  // Ränder wird die EXAKTE Silhouette des Renderers gleichmäßig auf N Punkte abgetastet → gleiche
  // Struktur → SMIL <animate> interpoliert `d` nativ (gebacken/deterministisch). Teller sind raus.
  function clearGhost() { if (ghostTimer) { clearInterval(ghostTimer); ghostTimer = null; } }
  function ghostResampleR(f, N) {                               // Radius je Höhenstufe (unten→oben), cm
    var o = f.o, yr = o[o.length-1][1], out = [];
    for (var k = 0; k < N; k++) {
      var y = yr * k / (N-1), r = o[o.length-1][0];
      for (var j = 1; j < o.length; j++) { if (o[j][1] >= y) { var a=o[j-1], b=o[j], t=(y-a[1])/((b[1]-a[1])||1); r=a[0]+(b[0]-a[0])*t; break; } }
      out.push(r);
    }
    return out;
  }
  // Profilbasierte Silhouette: Punkt i = gleiche Struktur-/Höhenposition über ALLE Formen → strukturelle
  // Korrespondenz → sauberes Morphen ohne quer wandernde/kreuzende Linien. (Seiten = ±r(y), Kappen = Ellipsen.)
  function smoothArr(a, passes) {                               // sanftes [.25,.5,.25]-Glätten → weichere Außenlinien (Ridges/Kanten)
    for (var p = 0; p < (passes || 1); p++) { var o = a.slice(); for (var i = 1; i < a.length-1; i++) o[i] = a[i-1]*0.25 + a[i]*0.5 + a[i+1]*0.25; a = o; }
    return a;
  }
  function smoothPts(pts, passes) {                             // geschlossenes Nachbar-Mittel → rundet ALLE Ecken (Fuß-Spur, Bauchknick, Rand)
    var n = pts.length;
    for (var p = 0; p < passes; p++) {
      var o = [];
      for (var i = 0; i < n; i++) { var a = pts[(i-1+n)%n], b = pts[i], c = pts[(i+1)%n]; o.push([a[0]*0.25+b[0]*0.5+c[0]*0.25, a[1]*0.25+b[1]*0.5+c[1]*0.25]); }
      pts = o;
    }
    return pts;
  }
  function ghostProfilePts(f, N, M) {
    var rs = smoothArr(ghostResampleR(f, N), 2), yr = fH(f), ro = fRim(f), baseR = rs[0];
    var roy = ro*S*K, basey = baseR*S*K, pts = [];
    for (var i = 0; i < N; i++) pts.push([-rs[i]*S, -(yr*i/(N-1))*S]);                                   // linke Kante unten→oben
    for (var m = 1; m < M; m++) { var th = Math.PI*(1-m/M); pts.push([Math.cos(th)*ro*S, -yr*S - Math.sin(th)*roy]); }  // Rand hinten
    for (var i2 = N-1; i2 >= 0; i2--) pts.push([rs[i2]*S, -(yr*i2/(N-1))*S]);                            // rechte Kante oben→unten
    for (var m2 = 1; m2 < M; m2++) { var t2 = Math.PI*(m2/M); pts.push([Math.cos(t2)*baseR*S, Math.sin(t2)*basey]); }   // Fuß vorn
    return pts;
  }
  function ghostForms() {                                       // nur Cups C1/C2/C3 in allen Formen (Edge/Bevel/Special) → subtiler, sauberer Morph
    var codes = ['C1', 'C2', 'C3'], out = [], seen = {};
    TYPES.forEach(function (t) {
      if (codes.indexOf((t.typ || '').toUpperCase()) < 0) return;
      t.forms.forEach(function (f) { var k = f.code || (t.typ + f.form); if (!seen[k]) { seen[k] = 1; out.push(f); } });
    });
    if (!out.length) TYPES.forEach(function (t) { if (t.typ.charAt(0) === 'C') t.forms.forEach(function (f) { out.push(f); }); });
    out.sort(function (a, b) { return fMaxR(a) - fMaxR(b); });   // schmal → breit; per Ping-Pong wieder zurück
    return out;
  }
  function renderGhost() {
    var stage = $('[data-stage]'); clearGhost();
    if (!TYPES.length) { stage.style.height = ''; stage.innerHTML = ''; return; }
    var seq = ghostForms(); if (!seq.length) { stage.innerHTML = ''; return; }
    // Punkte in weiche geschlossene Kurve (Catmull-Rom → kubische Beziers) → keine Ecken/Facetten.
    function smoothClosed(pts) {
      var m = pts.length, d = 'M ' + pts[0][0].toFixed(1) + ' ' + pts[0][1].toFixed(1);
      for (var i = 0; i < m; i++) {
        var p0 = pts[(i-1+m)%m], p1 = pts[i], p2 = pts[(i+1)%m], p3 = pts[(i+2)%m];
        var c1x = p1[0] + (p2[0]-p0[0])/6, c1y = p1[1] + (p2[1]-p0[1])/6;
        var c2x = p2[0] - (p3[0]-p1[0])/6, c2y = p2[1] - (p3[1]-p1[1])/6;
        d += ' C ' + c1x.toFixed(1)+' '+c1y.toFixed(1)+' '+c2x.toFixed(1)+' '+c2y.toFixed(1)+' '+p2[0].toFixed(1)+' '+p2[1].toFixed(1);
      }
      return d + ' Z';
    }
    var N = 34, M = 12, kf = seq.map(function (f) {
      var pts = smoothPts(ghostProfilePts(f, N, M), 2);         // Ecken vorab runden → Catmull-Rom schwingt nicht über (keine Fuß-Spur)
      var topY = 1e9, botY = -1e9; pts.forEach(function (p) { if (p[1]<topY) topY=p[1]; if (p[1]>botY) botY=p[1]; });
      var midY = (topY + botY) / 2;
      pts = pts.map(function (p) { return [p[0], p[1] - midY]; });   // vertikal zentrieren → Morph aus der Mitte heraus
      // Öffnungsellipse aus der GEGLÄTTETEN Silhouette ableiten → passt sich der schmaleren Kontur an, bleibt drin.
      var t2 = topY - midY, band = t2 + (botY - topY) * 0.18, rimHalf = 0;
      pts.forEach(function (p) { if (p[1] <= band) { var ax = Math.abs(p[0]); if (ax > rimHalf) rimHalf = ax; } });
      var erx = rimHalf * 0.88;                                  // etwas größer → dünnerer Rand-Ring (v.a. bei breiten Schalen)
      return { pts: pts, d: smoothClosed(pts), cy: (t2 + rimHalf*K).toFixed(1), rx: erx.toFixed(1), ry: (erx*K).toFixed(1) };
    });
    var minx = 1e9, maxx = -1e9, miny = 1e9, maxy = -1e9;
    kf.forEach(function (k) { k.pts.forEach(function (p) { if (p[0]<minx)minx=p[0]; if(p[0]>maxx)maxx=p[0]; if(p[1]<miny)miny=p[1]; if(p[1]>maxy)maxy=p[1]; }); });
    // Gleiches Padding + gleiche stageFrame-Pipeline wie das echte Einzelobjekt → identisches 5:7-Framing (nicht gezoomt).
    var vbx = minx - 8, vby = miny - 10, vbw = (maxx - minx) + 16, vbh = (maxy - miny) + 34;
    var fr = stageFrame(vbw, vbh); stage.style.height = fr.frameH + 'px';
    var dvals = [], cy = [], rx = [], ry = [];
    function push(k) { dvals.push(k.d); cy.push(k.cy); rx.push(k.rx); ry.push(k.ry); }
    var order = kf.concat(kf.slice(1, -1).reverse());  // Ping-Pong schmal→breit→schmal → keine großen Sprünge/Überschneidungen
    order.forEach(function (k) { push(k); push(k); });  // je Form: hinmorphen + kurz halten
    push(order[0]);                                     // Loop schließen (kleiner Schritt)
    var n = dvals.length, kt = [], ks = [];
    for (var i = 0; i < n; i++) kt.push((i/(n-1)).toFixed(4));
    for (var s = 0; s < n-1; s++) ks.push('.42 0 .58 1');
    var timing = 'calcMode="spline" keyTimes="'+kt.join(';')+'" keySplines="'+ks.join(';')+'" dur="'+(order.length*2.6).toFixed(1)+'s" repeatCount="indefinite"';
    var col = 'rgba(var(--color-foreground),0.6)';
    stage.innerHTML =
      '<div class="setcfg__ghostbox" data-ghost>' +
        '<svg class="setcfg__ghost" width="'+fr.oWpx+'" height="'+fr.oHpx+'" viewBox="'+vbx.toFixed(1)+' '+vby.toFixed(1)+' '+vbw.toFixed(1)+' '+vbh.toFixed(1)+'" preserveAspectRatio="xMidYMid meet">'+
          '<path fill="rgba(var(--color-foreground),0.045)" stroke="'+col+'" stroke-width="0.9" vector-effect="non-scaling-stroke" stroke-linejoin="round"><animate attributeName="d" values="'+dvals.join(';')+'" '+timing+'/></path>'+
          '<ellipse cx="0" fill="none" stroke="'+col+'" stroke-width="0.9" vector-effect="non-scaling-stroke"><animate attributeName="cy" values="'+cy.join(';')+'" '+timing+'/><animate attributeName="rx" values="'+rx.join(';')+'" '+timing+'/><animate attributeName="ry" values="'+ry.join(';')+'" '+timing+'/></ellipse>'+
        '</svg>'+
        '<div class="setcfg__ghosthint caption-with-letter-spacing">Pick a form, a glaze and a type below to start your set</div>'+
      '</div>';   /* Geist als Icon oben, Cue zentriert darunter (Folke 2026-07-14) */
  }
  // Beim Auswählen des ersten Stücks: Cross-Dissolve — Geist-Umriss löst sich auf, während das echte
  // Gefäß an derselben Stelle einblendet (materialisiert sich), statt hartem Fade+Drop.
  function ghostToStack() {
    var stage = $('[data-stage]'), ghost = stage.querySelector('[data-ghost]');
    render(false);                                             // Stapel statisch (kein Drop) → sauberes Auflösen
    if (reduced()) return;
    // Saubere Übergabe (Folke 2026-07-14): Geist-Icon + Cue schnell raus, das echte Gefäß wächst sanft
    // ein (Fade + leichtes Scale aus der Mitte) — kein mismatchtes Überblenden Icon↔Vollgröße mehr.
    var svg = stage.querySelector('svg');
    if (svg) {
      svg.style.transformOrigin = 'center center';
      svg.style.opacity = '0'; svg.style.transform = 'scale(0.92)';
      svg.style.transition = 'opacity var(--dur-slow,.5s) var(--ease,ease), transform var(--dur-slow,.5s) var(--ease,ease)';
      void svg.getBoundingClientRect().width;
      requestAnimationFrame(function () { svg.style.opacity = ''; svg.style.transform = ''; });
    }
    if (ghost) {
      ghost.style.pointerEvents = 'none';
      ghost.style.transition = 'opacity var(--dur-fast,.26s) var(--ease,ease), transform var(--dur-fast,.26s) var(--ease,ease)';
      stage.appendChild(ghost);                                // Umriss als Overlay, blendet zügig weg
      void ghost.getBoundingClientRect().width;
      ghost.style.opacity = '0'; ghost.style.transform = 'scale(1.06)';
      setTimeout(function () { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, 320);
    }
  }
  // ×-Löschbutton (HTML-Overlay, konstante Pixelgröße), mittig auf der Vorderwand des Objekts.
  // SVG-CSS-Transitions sind über getScreenCTM/getBBox NICHT live abfragbar (liefern nur den Zielwert),
  // darum läuft der Button per EIGENER, gleich getakteter CSS-Transition synchron mit: Start = genestete
  // Lage (Gruppen-CTM), Ziel = + data-mv·Scale (explodierte Lage). Ohne Bewegung direkt an die Ziel-Lage.
  var TR_HOVER = 'border-color var(--dur-fast,.2s) var(--ease,ease), background-color var(--dur-fast,.2s) var(--ease,ease)';
  function placeDelBtn(animate) {
    var btn = $('[data-delbtn]'); if (!btn) return;
    var stage = $('[data-stage]'), svg = stage && stage.querySelector('svg');
    var ves = (delIdx >= 0 && svg) ? stage.querySelector('.setcfg__ves[data-idx="' + delIdx + '"]') : null;
    if (!ves) { btn.hidden = true; return; }
    var ctm; try { ctm = ves.getScreenCTM(); } catch (e) { btn.hidden = true; return; }
    if (!ctm) { btn.hidden = true; return; }
    btn.hidden = false;
    var cy = +ves.getAttribute('data-cy') || 0;
    var p = svg.createSVGPoint(); p.x = 0; p.y = cy;           // fester Vorderwand-Punkt im Objekt-Lokalsystem
    var base = p.matrixTransform(ctm), host = (btn.offsetParent || stage).getBoundingClientRect();
    var animEl = ves.querySelector('.setcfg__ves-anim');
    var mv = animEl ? (+animEl.getAttribute('data-mv') || 0) : 0;
    var sx = (base.x - host.left), sy = (base.y - host.top), dy = mv * (ctm.d || 1);
    if (animate && Math.abs(dy) > 0.5) {                       // synchron zum Objekt an die Ziel-Lage gleiten
      btn.style.transition = 'none'; btn.style.left = sx.toFixed(1) + 'px'; btn.style.top = sy.toFixed(1) + 'px';
      void btn.getBoundingClientRect().width;
      requestAnimationFrame(function () {
        btn.style.transition = 'left var(--dur-slow,.55s) var(--ease,ease), top var(--dur-slow,.55s) var(--ease,ease), ' + TR_HOVER;
        btn.style.top = (sy + dy).toFixed(1) + 'px';
      });
    } else {                                                   // ruhend: direkt an die aktuelle Lage
      btn.style.transition = TR_HOVER; btn.style.left = sx.toFixed(1) + 'px'; btn.style.top = (sy + dy).toFixed(1) + 'px';
    }
  }
  // ×-Button ausblenden + ggf. wieder nesten (temporäres Explodieren zurücknehmen).
  function hideDel() {
    if (delTimer) { clearTimeout(delTimer); delTimer = null; }
    delIdx = -1; active = -1;
    if (gNest && !dispNest) { dispNest = true; stageAnim = 'toggle'; render(); }
    else renderStage(false);
  }
  // Maßzeile für die Zusammenstellung (aus form_spec/SETCFG_SPECS).
  // Nur Maße (cm) — Füll-/Serviermenge (ml) bewusst NICHT (Folke 2026-07-15): die ml stehen
  // schon auf der Picker-Kachel, in der Zusammenstellung sind sie Ballast.
  function specLine(code) {
    var s = SPECS[code]; if (!s) return '';
    var p = [];
    if (s.h) p.push('H ' + s.h);
    if (s.w) p.push('Ø ' + s.w);
    if (s.op) p.push('brim ' + s.op);
    return p.join(' · ');
  }
  // Rabatt-Stufen als EIN Objekt: Segmente (erreicht = ausgefüllt), Ersparnis in EUR, ein Klartextsatz.
  // Ersetzt Leiste + „n more for −x%" + Satz unter dem Picker, die dasselbe dreimal sagten (Folke 2026-07-15).
  function renderTiers(n, disc, sub) {
    var el = $('[data-tiers]'); if (!el) return;
    var steps = THRESH.map(function (th, i) {
      return '<span class="setcfg__tier' + (n >= th ? ' is-on' : '') + '">' +
        '<span class="setcfg__tier-n">' + th + '+</span>' +
        '<span class="setcfg__tier-d">−' + DISCS[i] + '%</span></span>';
    }).join('');
    // Ersparnis nur nennen, wenn sie existiert — eine „0 EUR"-Zeile wäre Lärm.
    var save = disc ? money(Math.round(sub) - Math.round(sub * (1 - disc / 100))) : '';
    var nt = nextTier(n), next;
    if (nt) next = 'Add ' + nt.need + (n ? ' more ' : ' ') + (nt.need === 1 ? 'piece' : 'pieces') + ' to save ' + nt.disc + '%.';
    else next = 'Top tier reached. Every piece in this set is ' + disc + '% off.';
    el.innerHTML =
      '<div class="setcfg__tiers-head">' +
        '<span class="setcfg__tiers-lbl">Set discount</span>' +
        '<span class="setcfg__tiers-save">' + (save ? 'You save ' + save : '') + '</span>' +
      '</div>' +
      '<div class="setcfg__ladder">' + steps + '</div>' +
      '<p class="setcfg__tiers-next">' + next + '</p>';
  }
  // Zusammenstellung: gleiche Artikel (Typ×Form×Glasur) gebündelt (×N), zeilenweise löschbar.
  function renderSummary() {
    var el = $('[data-summary]'); if (!el) return;
    if (!sel.length) { el.innerHTML = '<div class="setcfg__sum-empty caption-with-letter-spacing">Nothing chosen yet. Pick a form, a glaze and a type to start.</div>'; return; }
    var groups = [], gmap = {};
    sel.forEach(function (it, idx) {
      var key = it.t + '|' + it.form + '|' + it.g;
      if (gmap[key] == null) { gmap[key] = groups.length; groups.push({ it: it, key: key, qty: 1, first: idx }); }
      else groups[gmap[key]].qty++;
    });
    el.innerHTML = groups.map(function (gr) {
      var it = gr.it, t = TYPES[it.t], f = formOf(it), sp = specLine(f.code);
      var priceHtml = gr.qty > 1 ? '<span class="setcfg__row-ep">(' + money(t.price) + ')</span> ' + money(t.price * gr.qty) : money(t.price);
      return '<div class="setcfg__row">' +
        '<span class="setcfg__row-art">' + artFixed(f, GLAZES[it.g].rgb, { brush: isBrush(it.g), seed: 's' + (it.id != null ? it.id : gr.first), shine: glazeShine(it.g), rawOutside: TYPES[it.t] && TYPES[it.t].ni }) + '</span>' +
        '<span class="setcfg__row-main">' +
          '<span class="setcfg__row-name"><span class="setcfg__row-qty">' + gr.qty + '×</span> ' + t.name + ' <span class="setcfg__row-code">' + f.code + '</span></span>' +
          '<span class="setcfg__row-meta">' + f.form + ' · ' + GLAZES[it.g].name + '</span>' +
          (sp ? '<span class="setcfg__row-dims">' + sp + '</span>' : '') +
        '</span>' +
        '<span class="setcfg__row-price">' + priceHtml + '</span>' +
        '<button type="button" class="setcfg__row-del" data-delkey="' + gr.key + '" aria-label="Remove row">&times;</button>' +
      '</div>';
    }).join('');
    el.querySelectorAll('.setcfg__row-del').forEach(function (b) { b.onclick = function () { var key = b.dataset.delkey; if (delTimer) { clearTimeout(delTimer); delTimer = null; } delIdx = -1; dispNest = gNest; sel = sel.filter(function (it) { return it.t + '|' + it.form + '|' + it.g !== key; }); active = -1; render(); }; });
  }
  // Chargenschluss + Ready-Datum aus DERSELBEN Uhr wie der Countdown im Intro. Gibt null zurueck,
  // wenn keine Uhr da ist (dann greift die Prosa aus dem Setting) — nie ein geratenes Datum.
  function readyDates() {
    var clock = document.querySelector('.setcfg [data-countdown], .setcfg__lead');
    if (!clock || typeof clock.target !== 'function') return null;
    var close = clock.target();
    if (!close || isNaN(close.getTime())) return null;
    var root = $('[data-setcfg]') || document.querySelector('.setcfg');
    var wochen = parseInt((root && root.getAttribute('data-ready-weeks')) || '4', 10) || 4;
    var ready = new Date(close.getTime());
    ready.setDate(ready.getDate() + wochen * 7);
    var p = function (n) { return String(n).padStart(2, '0'); };
    return {
      ready: p(ready.getDate()) + '.' + p(ready.getMonth() + 1) + '.' + ready.getFullYear(),
      batch: close.getFullYear() + '-' + p(close.getMonth() + 1)
    };
  }

  var CTA_BASE = (function () { var c = $('[data-cta]'); return c ? c.textContent.trim() : 'Pre-order set'; })();
  function render(justAdded) {
    renderStage(justAdded);
    var n = sel.length, disc = discFor(n);
    // Führung: „nächster Schritt" je Zustand. Wortlaut Schreiber 2026-07-15 (device-agnostisch statt „tap";
    // gefüllt ohne Zustands-Claim „ready" — bei 1 Teil irreführend, nennt stattdessen die zwei nächsten Aktionen).
    var gd = $('[data-guide]');
    if (gd) gd.textContent = n
      ? 'Add another, or scroll down to review and pre-order your set.'
      : 'Choose a form and a glaze above, then select a type to add your first piece.';
    var sub = sel.reduce(function (s, it) { return s + TYPES[it.t].price; }, 0), now = Math.round(sub*(1-disc/100));
    $('[data-caption]').innerHTML = n
      ? (n === 1 ? '1 piece' : n+' pieces')+' <span class="setcfg__sep">·</span> '+(disc ? '<span class="setcfg__strike">'+money(sub)+'</span><span class="setcfg__disc">'+money(now)+'</span>' : money(sub))
      : '';
    renderTiers(n, disc, sub);
    renderSummary();
    var rst = $('[data-reset]'); if (rst) { rst.hidden = !n; rst.onclick = function () { if (delTimer) { clearTimeout(delTimer); delTimer = null; } delIdx = -1; dispNest = gNest; sel = []; active = -1; render(); }; }
    renderPicker();                                            // Karten neu → Stückzahl-Zähler aktualisieren
    $('[data-picker]').querySelectorAll('.setcfg__pk').forEach(function (b) { b.disabled = sel.length >= MAX; });
    var cta = $('[data-cta]');
    cta.disabled = !n;
    cta.textContent = n
      ? CTA_BASE + '  ·  ' + (n === 1 ? '1 piece' : n + ' pieces') + '  ·  ' + money(now)
      : 'Add a piece to start';   // CUSTOM (Folke 2026-07-17): Hinweis IM disabled Button statt „Pre-order set"
    var ctaS = $('[data-cta-sticky]');                         // Mitlaufende Leiste: führt zur Übersicht (nicht direkt Cart)
    if (ctaS) { ctaS.disabled = !n; ctaS.textContent = n
      ? 'Review your set  ·  ' + (n === 1 ? '1 piece' : n + ' pieces') + '  ·  ' + money(now)
      : 'Review your set'; }
  }

  // Countdown: liegt jetzt in countdown-clock.js (Custom Element, Monatsrhythmus) — hier nichts mehr.

  // Nesting-Toggle (Standard an) — Stil/Position wie der In-Use-Toggle der Artikelseite.
  var ntgl = $('[data-nest-toggle]');
  if (ntgl) ntgl.onclick = function () {
    if (delTimer) { clearTimeout(delTimer); delTimer = null; } delIdx = -1;   // ×-Modus beenden
    gNest = !gNest; dispNest = gNest;
    ntgl.classList.toggle('is-active', gNest);
    ntgl.setAttribute('aria-checked', gNest ? 'true' : 'false');
    stageAnim = 'toggle';
    render();
  };
  // ×-Löschbutton (HTML-Overlay) — löscht das angetippte Stück, nimmt das temporäre Explodieren zurück.
  var delBtn = $('[data-delbtn]');
  if (delBtn) delBtn.onclick = function () {
    if (delIdx < 0) return;
    var di = delIdx;
    if (delTimer) { clearTimeout(delTimer); delTimer = null; }
    delIdx = -1; active = -1; dispNest = gNest;
    sel.splice(di, 1);
    render();
  };

  // Vorbestellen: jedes Stück als Made-to-order×Form-Variante (f.vid, tracked:false) in den Cart.
  // Form+Glasur bleiben zusätzlich Line-Item-Properties (Glasur nicht in der Variante; Form+Glasur =
  // Contract für die Discount-Function). Fallback auf Studio-vid, falls einer Form die MTO-Variante fehlt.
  // Gleiche Variante×Glasur → eine Zeile mit Menge. Rabatt macht die Discount-Function im Checkout.
  function addToCart() {
    var btn = $('[data-cta]'); if (!btn || btn.disabled || !sel.length) return;
    var groups = {}, order = [];
    // Lieferzeit als Line-Item-Property → landet in Order + Bestätigungsmail (Folke 2026-07-14).
    var readyVal = root.getAttribute('data-delivery') || '';
    sel.forEach(function (it) {
      var t = TYPES[it.t]; if (!t) return;
      var f = t.forms[it.form]; if (!f) return;
      // Strikt die MTO-Variante: kein Rueckfall auf t.vid (Studio). Die Set-Seite ist Vorbestellung;
      // eine Studio-Variante hier waere immer falsch. Kommt keine ID, wird nichts gelegt.
      var vid = f.vid; if (!vid) return;
      var gName = GLAZES[it.g] ? GLAZES[it.g].name : '';
      var key = vid + '|' + f.form + '|' + gName;
      if (!groups[key]) {
        // Form NICHT mehr als Property: sie steckt seit dem Varianten-Umbau in der Variante selbst
        // (Type×Form + SKU) und stand im Warenkorb sonst doppelt. Glasur bleibt Property — sie ist
        // keine Varianten-Achse und existiert nur hier (Folke 2026-07-15).
        var props = { Glasur: gName };
        // Delivery als DATUM statt Prosa (Folke 2026-07-16): gerechnet aus target() derselben Uhr,
        // die den Countdown im Intro speist — nicht aus einem zweiten, handgepflegten Wert. Sonst
        // laufen Seite und Bestellung auseinander (siehe Workshop-Kalender).
        // `_batch` beginnt mit Unterstrich: Shopify-Konvention, das Theme blendet solche Properties
        // im Warenkorb aus, im Admin stehen sie. Damit kann Folke Bestellungen nach Charge filtern,
        // ohne dass der Kunde eine kryptische Zeile sieht.
        var fr = readyDates();
        if (fr) { props.Delivery = 'Ready around ' + fr.ready; props._batch = fr.batch; }
        else if (readyVal) { props.Delivery = readyVal; }
        groups[key] = { id: vid, quantity: 0, properties: props }; order.push(key);
      }
      groups[key].quantity++;
    });
    var items = order.map(function (k) { return groups[k]; });
    if (!items.length) return;
    var lbl = btn.textContent; btn.disabled = true; btn.textContent = 'Adding to cart…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = lbl; });
  }
  var ctaBtn = $('[data-cta]'); if (ctaBtn) ctaBtn.onclick = addToCart;
  // Mitlaufende Leiste führt zur Übersicht („check your selection"), NICHT direkt in den Cart — die
  // Bestellung löst der Haupt-CTA unter der Zusammenstellung aus (Folke 2026-07-17).
  var ctaStk = $('[data-cta-sticky]');
  if (ctaStk) ctaStk.onclick = function () {
    if (!sel.length) return;
    var t = root.querySelector('.setcfg__summary-wrap') || $('[data-summary]');
    if (t) t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
  };

  if (!TYPES.length) { var pk = $('[data-picker]'); if (pk) pk.innerHTML = '<div class="setcfg__hint">Forms are being added. Back shortly.</div>'; }
  else { renderFormSel(); renderGlazeSel(); renderPicker(); render(); }

  // CUSTOM Render-Hook (Folke 2026-07-14): exponiert den echten Seiten-Renderer für die
  // Produktbild-Pipeline (weiße 5:7-Renders, konstanter Maßstab). Read-only, kein UI-Effekt.
  try { window.SETCFG_RENDER = { vessel: vesselSVG, geo: geo, TYPES: TYPES, GVB: GVB, S: S, K: K }; } catch (e) {}
})();
